import { Component, inject, input, Input } from '@angular/core'
import { GroupModel, ProductOption } from '../../models/group-model'
import { DetailsToggleModule } from '@inst-iot/bosch-angular-ui-components'
import { TitleCasePipe } from '@angular/common'
import { UserTableComponent } from '../user-table/user-table.component'
import { MemberModel } from '../../models/member-model'
import { ToggleStateService } from '../../service/toggle-state.service'

@Component({
  selector: 'app-group',
  imports: [DetailsToggleModule, TitleCasePipe, UserTableComponent],
  templateUrl: './group.component.html',
  styleUrl: './group.component.scss',
})
export class GroupComponent {
  public groupModel = input.required<GroupModel>()
  public adminPermissions = input.required<string[]>()
  private toggleStateService = inject(ToggleStateService)

  getGroupToggleKey(): string {
    return this.groupModel().group
  }

  getGroupIsOpen(): boolean {
    return this.toggleStateService.getToggleState(
      this.getGroupToggleKey(),
      true,
    )
  }

  onGroupToggleChange(isOpen: boolean): void {
    this.toggleStateService.setToggleState(this.getGroupToggleKey(), isOpen)
  }

  getMembersOfProduct(members: MemberModel[], product: ProductOption) {
    return members.filter((member) => {
      return member.products.includes(product.name)
    })
  }

  checkIfAdminOfProduct(product: ProductOption) {
    return this.adminPermissions().some(
      (p: string) => p === `${product.name}.admin`,
    )
  }
}
